export default "__VITE_ASSET__CQx8nYkZ__"